module.exports = __webpack_public_path__ + "static/IMG_2128-2e6594f0c9c72701728e2995ef8e04e8.jpg";